export const alignCenter = {
  textAlign: 'center',
}

export const alignRight = {
  textAlign: 'right',
}
